import React from 'react';

const About = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4">About MyCommunity Services</h1>
      <p>
        Hello, dear resident! Welcome to MyCommunity Services, a warm and friendly platform we’ve created just for our lovely community. We’re here to make living in our community easier, happier, and more connected for everyone.
      </p>

      <h3>What We Do</h3>
      <p>
        At MyCommunity Services, we bring all the tools you need into one simple place. Whether you’re a homeowner or a tenant, we help with things like managing your vehicle details, keeping track of guest visits, or even updating your profile. Our goal is to make community tasks feel light and easy, so you can focus on enjoying your time here.
      </p>

      <h3>Why We’re Here</h3>
      <p>
        We started this platform with one big dream: to make our community a better place for all of us. By keeping details like resident information, vehicle details, and guest visits, we can:
      </p>
      <ul>
        <li>
          Organize parking in a fair and smooth way, helping to reduce parking issues and make sure everyone has a spot.
        </li>
        <li>
          Stay connected with you easily, sharing important updates or notices to keep our community running smoothly.
        </li>
      </ul>
      <p>
        Everything we do is to bring us closer as a community and make living here more peaceful and enjoyable for everyone.
      </p>

      <h3>Our Promise to You</h3>
      <p>
        We care about you and your trust in us. That’s why we work hard to keep things simple, safe, and friendly. We’re always here to support you, and we’ll keep improving to make MyCommunity Services the best it can be for our wonderful community.
      </p>

      <h3>Have Any Questions?</h3>
      <p>
        If you’d like to know more or have any questions, please feel free to reach out. You can contact our admin anytime, and they’ll be happy to help you with a smile. We’re here for you!
      </p>
    </div>
  );
};

export default About;